import type { tickets } from '@repletoryreach/sdk-api';
import { statusesForType } from './status';

/** The board's columns: every category but closed, which is where tickets leave the board. */
export const BOARD_CATEGORIES: readonly tickets.StatusCategory[] = ['new', 'open', 'pending', 'on_hold', 'solved'];

export type DropDecision =
  | { kind: 'same' }
  | { kind: 'none' }
  | { kind: 'one'; status: tickets.Status }
  | { kind: 'choose'; options: tickets.Status[] };

/**
 * What a drop on a column means for a ticket: nothing when it is already in that category; the one status of
 * that category its type may take; or a choice when the type has several.
 */
export function decideDrop(
  statuses: readonly tickets.Status[],
  ticket: { type: { id: string }; status: { category: string } },
  category: tickets.StatusCategory
): DropDecision {
  if (ticket.status.category === category) return { kind: 'same' };
  const options = statusesForType(statuses, ticket.type.id).filter((s) => s.category === category);
  if (options.length === 0) return { kind: 'none' };
  if (options.length === 1) return { kind: 'one', status: options[0]! };
  return { kind: 'choose', options };
}
